export default __webpack_public_path__ + "static/media/herobg.eb048ce6.mp4";